import { COMPONENTS_NAMESPACE, componentTranslations } from 'cpool-components/locales';
import { DEFAULT_UI_LANGUAGE } from 'cpool-constants';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { makeZodI18nMap } from 'zod-i18n-map';

import { TRANSLATION_VERSION } from '~/config';
import { SUPPORTED_UI_LANGUAGES } from '~/utils/language';

i18n.use(Backend)
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${TRANSLATION_VERSION}`,
        },
        fallbackLng: DEFAULT_UI_LANGUAGE,
        initImmediate: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        ns: ['translation', 'zod', COMPONENTS_NAMESPACE],
        // Add component library translations as bundled resources
        partialBundledLanguages: true,
        resources: {
            de: { [COMPONENTS_NAMESPACE]: componentTranslations.de },
            en: { [COMPONENTS_NAMESPACE]: componentTranslations.en },
        },
        supportedLngs: SUPPORTED_UI_LANGUAGES,
    });

z.setErrorMap(
    makeZodI18nMap({
        ns: ['zod'],
        t: i18n.t,
    }),
);

export const currencyFormat = new Intl.NumberFormat('de-DE', { currency: 'EUR', style: 'currency' }).format;
export const dateFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' }).format;
export const timeFormat = new Intl.DateTimeFormat('de-DE', { timeStyle: 'short' }).format;
export const weekdayFormat = new Intl.DateTimeFormat('de-DE', { weekday: 'long' }).format;
export const dateTimeFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium', timeStyle: 'short' }).format;
export const dateTimeShortFormat = new Intl.DateTimeFormat('de-DE', { dateStyle: 'short', timeStyle: 'short' }).format;
export const dateFullTimeShortFormat = new Intl.DateTimeFormat('de-DE', {
    dateStyle: 'full',
    timeStyle: 'short',
}).format;
export const numberFormat = new Intl.NumberFormat('de-DE').format;
export const dateTimeTwoDigitFormat = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
}).format;
export const dateTwoDigitYearFormat = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
}).format;
export default i18n;
